export default __webpack_public_path__ + "static/media/arrow_blue_top.756d9cb1.svg";